<template>
<div class="noticeList bgc padding-20">
    <el-collapse accordion @change="handelEditStatus" v-model="activeNames">
        <el-collapse-item v-for="(item,index) in tableData" :key="index" :name="item.innerid">
            <template slot="title">
                <div class="notice-subject" :class="[item.isread ? '' : 'isnoread']">
                    <div>{{item.subject}}</div>
                    <div>{{item.datetime}}</div>
                </div>
            </template>
            <div v-html="item.content"></div>
            <div class="link"><a :href="item.linkurl" target="_blank" class="tc-blue">{{item.linktext}}</a></div>
        </el-collapse-item>
    </el-collapse>
    <page :total="total" @getList="_getList" ref="page"></page>
</div>
</template>

<script>
import {getNoticeList, setNoticeStatus} from 'api/api'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'noticeList',
    data() {
        return {
            tableData: [],
            total: 0,
            param: {},
            activeNames: []
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handelEditStatus(val) {
            this.tableData.forEach(obj => {
                if (!obj.isread && obj.innerid === val) {
                    setNoticeStatus({
                        data: {
                            innerid: val
                        },
                        success: data => {
                            obj.isread = 1
                        },
                        error: data => {
                            this.$message.error(data.msg)
                        }
                    })
                    obj.isread = 1
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getNoticeList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.noticeList {
    .el-collapse{
        border-top-width: 0;
    }
    .el-collapse-item{
        padding: 0 20px;
        background: $bgcolor-white;
        .el-collapse-item__header{
        }
        .notice-subject{
            padding: 0 10px;
            @include flexBox(space-between);
            flex-grow: 1;
        }
        .link{
            margin-top: 10px;
        }
        .isnoread{
            border-left: 2px solid $bgcolor-base;
        }
    }
    .el-collapse-item__arrow{
        margin-left: 20px;
    }
    .el-collapse-item__content{
        padding: 10px 20px;
        background: $bgcolor-global;
    }
}
</style>
